import { CustomerSubscription } from 'interfaces/ApiTypeAliases';

const mailProduct = {
  orderState: 'None',
  role: {
    isPayer: true,
    isOwner: true,
    isUser: true,
    payer: '204808789',
    owner: '5690057590',
    user: '5690057590_1_1',
  },
  aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
  technology: 'Undefined',
  lid: 'FO102787',
  type: 'PartialSubscription',
  identifier: '10151',
  header: 'YouSee Mail',
  productCode: 'SP13_355_17',
  productType: 'Mail',
  customerId: {
    identifier: '1711-11-11-13.33.23.814244',
    type: 'Linkit',
  },
  customerPaidAccountNumbers: ['204808789'],
  packageMeta: {
    partOfPackage: false,
    identifier: null,
    packageProductCode: null,
    packageProductName: null,
  },
  addOns: [],
  backwardsCompatibleIdentifier: {
    identifier: '5CDE2DE60FD9BD518CDC4372FA01D2B6,SP13_355_17',
    isEnabled: true,
  },
};

export const packageSubs: CustomerSubscription[] = [
  {
    orderState: 'None',
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204045289',
      owner: '5331067483',
      user: '5331067483_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: 'EM127164',
    installationSequenceNumbers: [],
    type: 'PartialSubscription',
    identifier: '12:1',
    header: 'Bredbånd',
    productCode: 'PG_BB_04',
    productType: 'Broadband',
    customerPaidAccountNumbers: ['204045289'],
    packageMeta: {
      partOfPackage: true,
      identifier: 12,
      packageProductCode: 'SP57_825_03_TV',
      packageProductName: 'YouSee Tv Basis med Bredbånd',
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '9546F74CBA5164E69EB99C34590E63B1,SP57_825_03_TV,Broadband',
      isEnabled: true,
    },
  },
  {
    orderState: 'None',
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204045289',
      owner: '5331067483',
      user: '5331067483_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: 'EM127164',
    installationSequenceNumbers: [],
    type: 'PartialSubscription',
    identifier: '12:2',
    header: 'TV',
    productCode: 'PG_TV_BASIC_01',
    productType: 'Tv',
    customerPaidAccountNumbers: ['204045289'],
    packageMeta: {
      partOfPackage: true,
      identifier: 12,
      packageProductCode: 'SP57_825_03_TV',
      packageProductName: 'YouSee Tv Basis med Bredbånd',
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '9546F74CBA5164E69EB99C34590E63B1,SP57_825_03_TV,Tv',
      isEnabled: true,
    },
  },
];

export const mySubsMock = [
  ...packageSubs,
  mailProduct,
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204391921',
      owner: '5051070099',
      user: '5051070099_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '62604017',
    type: 'PartialSubscription',
    identifier: '4321',
    header: 'Mobil Fri Tale / 60 GB',
    productCode: 'SP01_758_14_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '4791-04-13-11.50.57.701794', type: 'Linkit' },
    customerPaidAccountNumbers: ['204391921'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '072A7B051632AC3A51BAEDB8926CBAA7,SP01_758_14_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204372367',
      owner: '5110038986',
      user: '5110038986_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '62604866',
    type: 'PartialSubscription',
    identifier: '4322',
    header: 'Fri Tale / 50 GB',
    productCode: 'SP01_758_08_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '4791-04-13-11.50.57.701794', type: 'Linkit' },
    customerPaidAccountNumbers: ['204372367'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'BF735DA5765A358FCF51981EFAAB4919,SP01_758_08_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204391295',
      owner: '5380070092',
      user: '5380070092_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '62605479',
    type: 'PartialSubscription',
    identifier: '4323',
    header: 'Fri Tale / 40 GB',
    productCode: 'SP01_758_05_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '4791-04-13-11.50.57.701794', type: 'Linkit' },
    customerPaidAccountNumbers: ['204391295'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'CDFB084AB78030B274D2916A1EEEB96F,SP01_758_05_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204392007',
      owner: '5461070090',
      user: '5461070090_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '62605510',
    type: 'PartialSubscription',
    identifier: '4324',
    header: 'Fri Tale / Fri Data',
    productCode: 'SP01_758_11_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '4791-04-13-11.50.57.701794', type: 'Linkit' },
    customerPaidAccountNumbers: ['204392007'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '784CC30879DBDAA219A5E845E8A2619F,SP01_758_11_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204392007',
      owner: '5461070090',
      user: '5461070090_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '62621451',
    type: 'PartialSubscription',
    identifier: '4325',
    header: 'Fri Tale/ 30 GB',
    productCode: 'SP01_758_02_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '4791-04-13-11.50.57.701794', type: 'Linkit' },
    customerPaidAccountNumbers: ['204392007'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '5B97CD84DAE79A55BD8C33E35B4FFD4B,SP01_758_02_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204145821',
      owner: '5702092689',
      user: '5702092689_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: '98124737',
    type: 'PartialSubscription',
    identifier: '4327',
    header: 'Fastnet',
    productCode: 'SP84_101_98',
    productType: 'LandLine',
    customerId: { identifier: '1591-04-08-15.01.26.612102', type: 'Linkit' },
    customerPaidAccountNumbers: ['204145821'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'F56D45FF1775B0341D8D30765FA0E527,SP84_101_98',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: false,
      isOwner: false,
      isUser: true,
      payer: null,
      owner: null,
      user: '5702092689_1_1',
    },
    aggregatedRole: { payer: 'Partial', owner: 'Partial', user: 'Full' },
    technology: 'Copper',
    lid: 'EM100995',
    type: 'PartialSubscription',
    identifier: '4328',
    header: 'Bredbånd garanteret 40/10, DSL',
    productCode: 'SP57_801_02_BB',
    productType: 'Broadband',
    customerId: { identifier: '1591-04-08-15.01.26.612102', type: 'Linkit' },
    customerPaidAccountNumbers: ['204145843'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'CF0011D07B247BE037453BDCF7AA8EB1,SP57_801_02_BB',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204297539',
      owner: '5830057887',
      user: '5830057887_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: '98126539',
    type: 'PartialSubscription',
    identifier: '4326',
    header: 'Fastnet',
    productCode: 'SP84_101_98',
    productType: 'LandLine',
    customerId: { identifier: '4161-12-13-10.20.10.614102', type: 'Linkit' },
    customerPaidAccountNumbers: ['204297539'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'A9FB90F8691EDF15A4EB3E54C479AF1F,SP84_101_98',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204042112',
      owner: '5100057484',
      user: '5100057484_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: '99184800',
    type: 'PartialSubscription',
    identifier: '4308',
    header: 'Fastnet',
    productCode: 'SP84_101_98',
    productType: 'LandLine',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204042112'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '1381356C339412E300A40369789C1441,SP84_101_98',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204045988',
      owner: '5200077488',
      user: '5200077488_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Undefined',
    lid: '99192424',
    type: 'PartialSubscription',
    identifier: '4309',
    header: 'Bredbånd og Fastnet 50/10, DSL',
    productCode: 'SP57_811_01_PSTN_BB',
    productType: 'Package',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204045988'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'A3BE00135D97DC5047BA60450246EB7B,SP57_811_01_PSTN_BB',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204045289',
      owner: '5331067483',
      user: '5331067483_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Undefined',
    lid: 'EM127164',
    type: 'PartialSubscription',
    identifier: '4310',
    header: 'YouSee Tv Basis med Bredbånd',
    productCode: 'SP57_825_03_TV',
    productType: 'Package',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204045289'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '9546F74CBA5164E69EB99C34590E63B1,SP57_825_03_TV',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204045289',
      owner: '5331067483',
      user: '5331067483_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Undefined',
    lid: 'EM127164',
    type: 'PartialSubscription',
    identifier: '4311',
    header: 'YouSee Bredbåndstelefoni FriTale',
    productCode: 'SP57_860_01',
    productType: 'BroadbandTelephony',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204045289'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'F0E5B80CA02179C81A612DF57676940F,SP57_860_01',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204078994',
      owner: '5401062586',
      user: '5401062586_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '61146177',
    type: 'PartialSubscription',
    identifier: '4312',
    header: 'Mobil Fri Tale & 40 GB Basis',
    productCode: 'SP01_756_71_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204078994'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '016815808A56085020A2D97128F1E6AF,SP01_756_71_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204078994',
      owner: '5401062586',
      user: '5401062586_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '61145925',
    type: 'PartialSubscription',
    identifier: '4313',
    header: 'YouSee Mobilt Bredbånd 1 TB',
    productCode: 'SP01_757_37_MBB',
    productType: 'MobileBroadband',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204078994'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'EE056AA772AD852363163990C202F0FA,SP01_757_37_MBB',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204042161',
      owner: '5700057481',
      user: '5700057481_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Undefined',
    lid: '61636750',
    type: 'PartialSubscription',
    identifier: '4314',
    header: 'Bredbånd og Mobil 50/10, DSL',
    productCode: 'SP57_813_01_MOBIL_BB',
    productType: 'Package',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204042161'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '1BED91F8CE3ECBE9DCE896E991461FDB,SP57_813_01_MOBIL_BB',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204044081',
      owner: '5772057480',
      user: '5772057480_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'MobileNetwork',
    lid: '61636697',
    type: 'PartialSubscription',
    identifier: '4316',
    header: 'Fri Tale & 10 GB Basis',
    productCode: 'SP01_755_65_MOBIL',
    productType: 'Mobile',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204044081'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '20783163134A666C0A1DC680937FF078,SP01_755_65_MOBIL',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204044081',
      owner: '5772057480',
      user: '5772057480_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: 'EM127159',
    type: 'PartialSubscription',
    identifier: '4317',
    header: 'Bredbånd 20/2 Mbit',
    productCode: 'SP13_350_10',
    productType: 'Broadband',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204044081'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: 'CF019B20EF0A1EFF104F64C8F6556159,SP13_350_10',
      isEnabled: true,
    },
  },
  {
    role: {
      isPayer: true,
      isOwner: true,
      isUser: true,
      payer: '204044081',
      owner: '5772057480',
      user: '5772057480_1_1',
    },
    aggregatedRole: { payer: 'Full', owner: 'Full', user: 'Full' },
    technology: 'Copper',
    lid: 'EM127159',
    type: 'PartialSubscription',
    identifier: '4318',
    header: 'YouSee Bredbåndstelefoni FriTale',
    productCode: 'SP57_860_01',
    productType: 'BroadbandTelephony',
    customerId: { identifier: '9441-11-08-05.21.01.510819', type: 'Linkit' },
    customerPaidAccountNumbers: ['204044081'],
    packageMeta: {
      partOfPackage: false,
      identifier: null,
      packageProductCode: null,
      packageProductName: null,
    },
    addOns: [],
    backwardsCompatibleIdentifier: {
      identifier: '04894E45EE1A7AA85F08B814D2488514,SP57_860_01',
      isEnabled: true,
    },
  },
];
